import { useBottomMenu } from "./useBottomMenu";
import { SettingsIcon } from "client/components/common/Icons/SettingsIcon";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { ResizeSettings } from "../EditSettings/ResizeSettings/ResizeSettings";
import { SKIP_TOUCH_ID_BOTTOM_MODAL } from "components/common/BottomModal/useBottomModal";
import { MobileAction } from "../Action/MobileAction";
import { BottomSectionContainer } from "components/common/BottomModal/BottomSectionContainer";
import { Translate } from "components/common/Translate/Translate";

export const BottomMenu = () => {
    const { isOpen, open, close } = useBottomMenu();

    return (
        <div className="py-4 px-8 bg-white dark:bg-darkSurface-100 dark:border-t dark:border-t-darkSurface-600">
            <div
                className="dark:bg-darkPrimary-100 border border-irBlue-200 dark:border-darkSurface-400 rounded-xl flex items-center justify-center py-3 gap-4 text-irBlue-200 dark:text-white bg-white"
                onClick={open}
            >
                <div className="">
                    <SettingsIcon className="stroke-irBlue-200 dark:stroke-white" />
                </div>
                <div className="font-semibold capitalize">
                    <Translate keyName="enlarge-settings" />
                </div>
            </div>

            <BottomModal
                isOpen={isOpen}
                onClose={close}
                titleBar={
                    <div className="w-full flex items-center justify-between px-4 py-4 text-black dark:text-white font-semibold text-xl">
                        <div className="capitalize whitespace-nowrap">
                            <Translate keyName="enlarge-settings" />
                        </div>
                        <div
                            onClick={close}
                            id={SKIP_TOUCH_ID_BOTTOM_MODAL}
                            className="w-5 h-5 grid place-items-center rounded-full bg-irGray-200 dark:bg-darkSurface-200"
                        >
                            <CloseIcon />
                        </div>
                    </div>
                }
                bottomSection={
                    <BottomSectionContainer>
                        <MobileAction />
                    </BottomSectionContainer>
                }
                initialHeight="60vh"
                minimumHeight={0}
            >
                <ResizeSettings hideTitle={true} />
            </BottomModal>
        </div>
    );
};
